<template>
  <section class="green-home">
    <div class="container">
			<h2 class="green-home__title --fade-in-up" data-vertical-ivp-class="--animate">
				Green Home Energy Could be the Next Multi-Trillion Dollar Opportunity
			</h2>
      <ul class="list">
				<li class="--fade-in-up --delay-1" data-vertical-ivp-class="--animate">
					<img class="item-icon" src="~@/assets/green-home/money-icon.png" alt="money-icon">
					<p>Energy costs are soaring</p>
				</li>
				<li class="--fade-in-up --delay-2" data-vertical-ivp-class="--animate">
					<img class="item-icon" src="~@/assets/green-home/light-icon.png" alt="lightbulb-icon">
					<p>
						GeoSolar Technologies' Integrated
						Whole-Home Technology allows
						homes to generate 100% of their own
						clean, sustainable energy
					</p>
				</li>
				<li class="--fade-in-up --delay-3" data-vertical-ivp-class="--animate">
					<img class="item-icon" src="~@/assets/green-home/air-icon.png" alt="airpurifier-icon">
					<p>
						In home air purification and
						advanced AI based smart
						home technology add to
						homeowner value
					</p>
				</li>
      </ul>
      <CTA />
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/green-home.scss';
</style>

<script>
import CTA from '../components/cta.vue';

export default {
  name: 'GreenHome',
  data() {
    return {
    };
  },
	components: {
		CTA
	}
};
</script>

